import { useTranslation } from 'react-i18next';
import { Icon } from '../common/Icon';
import { getWebConfig } from '../../config/loadWebConfig';
import { useGetAliveQuery } from './aliveEndpoints';

const webBuildNumber = import.meta.env.VITE_BUILD_NUMBER ?? 'local';

/** Which builds this browser is talking to (SCF-D1), as a key/value card (QZ-D47). */
export const AlivePage = () => {
  const { t } = useTranslation();
  const { data, isLoading, isError } = useGetAliveQuery();
  const { apiUrl } = getWebConfig();

  return (
    <main className="qz-main">
      <div className="qz-container is-form">
        <div className="qz-page-header">
          <div>
            <h1>{t('alive.heading')}</h1>
            <p className="qz-sub">{t('alive.sub')}</p>
          </div>
        </div>
        <div className="qz-card">
          <div className="qz-card-body">
            <dl className="qz-kv">
              <dt>{t('alive.api')}</dt>
              <dd>
                {isLoading && (
                  <span className="qz-small qz-muted">
                    <span className="spinner-border spinner-border-sm me-1" aria-hidden="true" />
                    {t('alive.loading')}
                  </span>
                )}
                {data && <span className="qz-status is-approved">{t('alive.reachable')}</span>}
                {isError && <span className="qz-status is-rejected">{t('alive.unreachable')}</span>}
              </dd>
              <dt>{t('alive.apiBuild')}</dt>
              <dd className="qz-mono">{data?.buildNumber ?? '—'}</dd>
              <dt>{t('alive.environment')}</dt>
              <dd className="qz-mono">{data?.envType ?? '—'}</dd>
              <dt>{t('alive.webBuild')}</dt>
              <dd className="qz-mono">{webBuildNumber}</dd>
              <dt>{t('alive.apiUrl')}</dt>
              <dd className="qz-mono qz-small">{apiUrl}</dd>
            </dl>
            {isError && (
              <div className="alert alert-danger mt-3 mb-0">
                <Icon name="plug-circle-xmark" />
                <div>{t('alive.error', { apiUrl })}</div>
              </div>
            )}
          </div>
        </div>
      </div>
    </main>
  );
};

export default AlivePage;
